import React from "react";
import { TagPicker } from "rsuite";
import { SelectOption } from "./SearchableSelect";

interface Props {
  options: SelectOption[];
  value: (string | number)[];
  onChange: (value: (string | number)[]) => void;
  placeholder?: string;
  disabled?: boolean;
  cleanable?: boolean;
  className?: string;
}

/**
 * Multiseleção com BUSCA e pills. Wrapper do rsuite TagPicker padronizado para o NINA.
 * Permite selecionar vários registros (ex.: filtrar por vários clientes/projetos).
 */
const MultiSelect: React.FC<Props> = ({
  options,
  value,
  onChange,
  placeholder = "Selecione…",
  disabled = false,
  cleanable = true,
  className,
}) => (
  <TagPicker
    data={options}
    value={value as any}
    onChange={(v) => onChange((v as (string | number)[]) ?? [])}
    placeholder={placeholder}
    disabled={disabled}
    cleanable={cleanable}
    searchable
    block
    menuMaxHeight={280}
    className={className}
  />
);

export default MultiSelect;
